// extracted by mini-css-extract-plugin
module.exports = {"Container":"TextInput_Container__VAh03","error":"TextInput_error__1m8T5","Input":"TextInput_Input__2Kz5S","ErrorSpan":"TextInput_ErrorSpan__3OMzM"};